import { connect, MapStateToProps } from 'react-redux';
import { ApplicationState } from '../../store/types';
import { PresetNavigator, PresetNavigatorProps } from './PresetNavigator';

export const mapStateToProps: MapStateToProps<PresetNavigatorProps, any, ApplicationState> = (state, _) => ({
  preset: state.timeline.preset
});

export const PresetNavigatorContainer = connect(
  mapStateToProps,
  null
)(PresetNavigator);



// WEBPACK FOOTER //
// ./src/components/navbar/PresetNavigatorContainer.ts